import { Injectable, Inject } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { from } from 'rxjs';
import 'rxjs/add/operator/map'


import { DOCUMENT } from '@angular/platform-browser';

import { Constantes } from '../constantes/constantes';
import { DatosSesionService } from '../../paginas/servicios/datos-sesion.service';
import { Observable } from 'rxjs';


@Injectable()
export class CustomHttp {


  private resultado: Response;

  private baseUrl = Constantes.URL_SERVER_SAR;

  constructor(private http: Http, private datosSesion: DatosSesionService, @Inject(DOCUMENT) private document: any) { }

  private createAuthorizationHeader(headers: Headers) {
    headers.append('token', this.datosSesion.getToken());
  }

  private createJsonHeader(headers: Headers) {
    headers.append('Content-Type', 'application/json');
  }


  get(url, cabeceras: Headers[] = null) {

    let headers = new Headers();

    // se agrega la cabecera de token
    this.createAuthorizationHeader(headers);

    /**
     * mantenemos la sesion activa
     */
    // this.actividadSesion();

    // creamos un observable para el return

    return Observable.create(observer => {
      // se llama al get normal
      this.http.get(url, {
        headers: headers
      }).subscribe((result: Response) => {
        // si el estado es 200
        if (result.status === 200) {
          
          // Validar los tockens
          if (result.headers.getAll('token') ){
            this.datosSesion.setToken(
              result.headers.getAll('token')[0]
            );
          }else {
           // observer.error('NO EXISTE TOKEN');
          }
        }
        observer.next(result);
        observer.complete();
      }, (err) => {
        console.error('ERROR get Cust Detalle:... ' + err);
        //en caso de error        
        if (err.status === 403) {
          
          // this.logout();
        } else {
          observer.next(err);
          observer.complete();
        }
      }
        );
    });
  }

  post(url, data, cabeceras = null) {
    // metodo post propio
    let headers = new Headers();
    //se agrega la cabecera de token
    this.createAuthorizationHeader(headers);
    // y la cabecera de content-type
    this.createJsonHeader(headers);

    // mantenemos la sesion activa
    this.actividadSesion();


    // creamos un observable para el return
    return Observable.create(observer => {
      // se llama al post normal
      this.http.post(url, data, {
        headers: headers
      }).subscribe((result: Response) => {
        // si el estado es 200
        if (result.status === 200) {
          this.datosSesion.setToken(result.headers.getAll('token')[0]);
        }
        observer.next(result);
        observer.complete();
      }, (err) => {
        // en caso de error        
        if (err.status === 403) {
          this.logout();
        } else {
          observer.next(err);
          observer.complete();
        }
      }
        );
    });
  }

  put(url, data, cabeceras = null) {


    console.log('entra al put ' + url);
    console.log('entra al put ' + data);
    console.log('entra al debug put ' + cabeceras);
    // tslint:disable-next-line:comment-format
    //metodo put propio
    let headers = new Headers();
    //se agrega la cabecera de token
    this.createAuthorizationHeader(headers);
    //y la cabecera de content-type
    this.createJsonHeader(headers);

    // mantenemos la sesion activa
    //this.actividadSesion();


    console.log('activate sesion ');

    //creamos un observable para el return
    return Observable.create(observer => {
      //se llama al put normal
      this.http.put(url, data, {
        headers: headers
      }).subscribe((result: Response) => {

        console.log('suscribe  result custom http-->' + JSON.stringify(result) );
        //si el estado es 200
        if (result.status === 200) {
          // Validar los tockens
          if (result.headers.getAll('token') ){
            this.datosSesion.setToken(
              result.headers.getAll('token')[0]
            );
          }
        }
        observer.next(result);
        observer.complete();
      } , (err) => {        
        //en caso de error        
        if (err.status === 403) {
          this.logout();
        } else {
          observer.next(err);
          observer.complete();
        }
      }
        );
    });
  }

  delete(url) {
    //metodo delete propio
    let headers = new Headers();
    //creamos el header con el token
    this.createAuthorizationHeader(headers);

    // mantenemos la sesion activa
    this.actividadSesion();

    //creamos un observable para el return
    return Observable.create(observer => {
      //se llama al delete normal
      this.http.delete(url, {
        headers: headers
      }).subscribe((result: Response) => {
        //si el estado es 200
        if (result.status === 200) {
          this.datosSesion.setToken(result.headers.getAll('token')[0]);
        }
        observer.next(result);
        observer.complete();
      }, (err) => {
        //en caso de error        
        if (err.status === 403) {
          this.logout();
        } else {
          observer.next(err);
          observer.complete();
        }
      }
        );
    });
  }

  logout() {
    localStorage.clear();
    //xxx this.datosSesion.limpiar();
    this.document.location.href = Constantes.URL_LOGOUT;
  }



  actividadSesion() {
    this.http.get(this.baseUrl, { withCredentials: true })
      .subscribe((result: Response) => {
        //si el estado es 200
        if (result.status === 200) {
          const a = true;
        }
      }, (err) => {
        //en caso de error
        const a = false;
      });

  }
}
